// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1eBDK","author":"Table_author__23IkX","authorImage":"Table_authorImage__2gG3r","unreadRow":"Table_unreadRow__3pXRU"};